/**
 * Colours of the splash backdrop, per theme mode.
 *
 * Keep in step with the `--sp-*` custom properties in index.html: the static
 * preboot and the React splash have to paint the same frame.
 */
export interface SplashColors {
  bg: string;
  topEnd: string;
  bottomEnd: string;
  mid: string;
  shimmerPeak: string;
  shimmerEdge: string;
  edgeShadow: string;
}

const LIGHT: SplashColors = {
  bg: '#eff2f5',
  topEnd: '#d2d8e0',
  bottomEnd: '#e0e1e4',
  mid: 'rgba(239, 242, 245, 0.55)',
  shimmerPeak: 'rgba(210,216,224,0.55)',
  shimmerEdge: 'rgba(210,216,224,0)',
  edgeShadow: 'rgba(0,0,0,0.04)'
};

const DARK: SplashColors = {
  bg: '#121212',
  topEnd: '#1d2430',
  bottomEnd: '#1a1c20',
  mid: 'rgba(18, 18, 18, 0.55)',
  shimmerPeak: 'rgba(255,255,255,0.07)',
  shimmerEdge: 'rgba(255,255,255,0)',
  edgeShadow: 'rgba(255,255,255,0.04)'
};

export const getSplashColors = (mode: string): SplashColors =>
  mode === 'dark' ? DARK : LIGHT;
